<div class="edit-special-time-period__container">
  <div class="edit-special-time-period__container__day">
    <div>
      <span>{{ 'FRONTEND.FORMS.SPECIAL_HOURS.DATE' | translate }}</span>
    </div>
    <div>
      <div class="edit-special-time-period__container__date-picker">
        <glxy-datepicker
          (dateSelected)="onDateChange($event)"
          [selection]="'single'"
          [date]="selectedDate"
          [futureDates]="true"
        ></glxy-datepicker>
      </div>
      <span class="vertical-menu">
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="addHours()">
            <mat-icon>add</mat-icon>
            {{ 'FRONTEND.FORMS.SPECIAL_HOURS.ADD_HOURS' | translate }}
          </button>
          <button mat-menu-item (click)="deleteDate()">
            <mat-icon>delete</mat-icon>
            {{ 'FRONTEND.FORMS.SPECIAL_HOURS.REMOVE_DATE' | translate }}
          </button>
        </mat-menu>

        <button mat-icon-button color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </span>
    </div>
    <div>
      <span>{{ 'FRONTEND.FORMS.SPECIAL_HOURS.OPEN' | translate }}</span>
      <mat-slide-toggle [checked]="isOpen" (change)="toggleIsOpen()" [color]="'primary'"></mat-slide-toggle>
    </div>
  </div>
  <ng-container *ngIf="isOpen">
    <div *ngFor="let hour of _timePeriod; let i = index" class="edit-special-time-period__container__times">
      <forms-edit-time-span
        [value]="hour"
        (valueChange)="changeHours($event, i)"
        [allowDelete]="_timePeriod.length > 1"
        (deleted)="removeHours(i)"
      ></forms-edit-time-span>
    </div>
  </ng-container>
</div>
